export default "__VITE_ASSET___idPXQ7P__"